.aj{flex-shrink:0;}